import { z } from 'zod';
export const getTradingCompetitionLeaderboardQuerySchema = z.object({
    page: z.coerce.number().min(1).default(1),
    pageSize: z.coerce.number().min(1).max(100).default(20),
});
export const getTradingCompetitionLeaderboardPathSchema = z.object({
    subdomain: z.string(),
    tradingCompetitionId: z.string(),
});
export const getTradingCompetitionLeaderboardInputSchema = getTradingCompetitionLeaderboardQuerySchema.merge(getTradingCompetitionLeaderboardPathSchema);
export const getTradingCompetitionLeaderboardOutputSchema = z.object({
    status: z.enum(['computed', 'resyncing', 'outdated']).default('computed'),
    page: z.number(),
    totalPages: z.number(),
    totalRecords: z.number(),
    totalVolume: z.number(),
    data: z.array(z.object({
        userId: z.string(),
        name: z.string(),
        avatar: z.string().nullable(),
        rank: z.number(),
        volume: z.number(),
        expectedReward: z.number(),
    })),
});
